module.exports = __webpack_public_path__ + "static/img/theme-bg.797f29a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cert/theme-bg.png
// module id = zxA9
// module chunks = 126